<template>
  <component :is="tag" class="illustrated-rating">
    <div class="section-inner illustrated-rating-inner">
      <StoryblokComponent
        v-if="blok.image?.[0]"
        :blok="blok.image?.[0]"
        class="image"
        :size-hint="25"
      />
      <div class="rating-wrapper">
        <span class="bold size-l">
          <span class="size-2xl">{{ useFormattedNote(blok.note) }}</span>
          /{{ blok.base_rating }}
        </span>
        <StarRating :max="Number(blok.base_rating)" :note="Number(blok.note)" />
        <span class="size-2xs">{{
          useFormattedDescriptionNote(blok.description_note, blok.total_reviews)
        }}</span>
        <SimpleButton :link="blok.cta_link" class="link size-2xs">{{
          blok.cta_label
        }}</SimpleButton>
      </div>
    </div>
  </component>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});
</script>

<style lang="scss" scoped>
.illustrated-rating {
  .section-inner {
    @include for-desktop-up {
      grid-column: 4/-4;
    }
  }

  &-inner {
    @include pair-3;
    display: grid;
    grid-template-columns: repeat(18, 1fr);
    row-gap: 1.5rem;
    padding: 1.5rem 0;
    border-radius: $radius-m;

    @include for-tablet-portrait-up {
      grid-template-columns: repeat(14, 1fr);
      row-gap: 0;
      padding: 0;
      border-radius: $radius-l;
    }
  }

  .image {
    grid-column: 5 / -5;
    @include for-tablet-portrait-up {
      grid-column: 3 / span 4;
    }
    :deep(img) {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: contain;
    }
  }

  .rating-wrapper {
    grid-column: 2 / -2;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: center;
    justify-content: center;
    text-align: center;

    @include for-tablet-portrait-up {
      grid-column: span 5 / -3;
      padding: 3.125rem 0;
    }
  }
}
</style>
